import axios from 'axios'

// API base URL - adjust this to match your server configuration
// Use VITE_API_URL env var if set, otherwise use localhost in dev
// In production, use relative URL so Vercel can proxy to avoid CORS issues
const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? 'http://localhost:3007/api' : '/api')

// Token getter function - will be set by ClerkProvider wrapper
let getTokenFn: (() => Promise<string | null>) | null = null

/**
 * Set the token getter function (called from ClerkProvider wrapper)
 */
export function setTokenGetter(fn: () => Promise<string | null>) {
  getTokenFn = fn
}

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor to include Clerk session token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Get the session token using the token getter function
      if (getTokenFn) {
        const token = await getTokenFn()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    } catch (error) {
      // If getting token fails, continue without it
      // The backend will return 401 if authentication is required
      console.warn('[API] Failed to get Clerk token:', error)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default apiClient
